import { Box } from 'components/Material/index'
import { SideBarContainer } from '../SideBarContainer'
import { Progress } from 'components/Custom/Progress'

export const SidebarProgress = () => {
  return (
    <SideBarContainer>
      <Box className="flex flex-col h-screen justify-center items-center py-10">
        <Progress />
      </Box>
    </SideBarContainer>
  )
}
